import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import './style.scss';

const Button = ({
  className, text, theme = 'default', size = 'large', ...rest
}) => {
  return (
    <div
      className={cx('ap-primary-button', `is-${theme}`, `is-${size}`, className)}
      {...rest}
    >
      {text}
    </div>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  size: PropTypes.string,
  theme: PropTypes.string
};

export default Button;
